import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getIndexFromSlug } from "./GeoTabs";
import GeoTabs from "./GeoTabs";
import GeoTabPanels from "./GeoTabsPanels";
import { useMediaQuery, useTheme } from "@mui/material";

const GeoLayout = () => {
  const { tab } = useParams();
  const [value, setValue] = useState(() => getIndexFromSlug(tab));
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setValue(getIndexFromSlug(tab));
  }, [tab]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        minHeight: "85vh",
        maxWidth: "1200px",
        margin: "0 auto 3rem auto",
        gap: "3rem",
      }}
    >
      {isDesktop && (
        <Box
          sx={{
            backgroundColor: "#f0f0f0",
            flex: "2",
            alignSelf: "stretch", 
            borderTop: "0.4rem solid #000000",
            padding: "1rem 0 1rem 0",
          }}
        >
          <GeoTabs value={value} onChange={setValue} />
        </Box>
      )}

      <Box
        sx={{
          flex: "5",
          // Let the content column shrink, so wide code blocks and tables scroll
          // inside it instead of squeezing the sidebar.
          minWidth: 0,
          alignSelf: "stretch", 
          borderTop: "0.4rem solid #000000",
          padding: "1rem 0 0 0",
          width: isMobile ? "90vw" : "auto",
        }}
      >
        <GeoTabPanels value={value} />
      </Box>
      {/* {isDesktop && (
        <Box
          sx={{
            flex: "1.2",
            borderTop: "0.4rem solid #000000",
            padding: "1rem 0 1rem 0",
          }}
        >
          box three
        </Box>
      )} */}
    </Box>
  );
};

export default GeoLayout;
